import * as React from 'react'

import type Employee from 'modules/employees/store/models/Employee'

interface EmployeeContextProps {
  employee?: Employee
}

const EmployeeContext = React.createContext<EmployeeContextProps | null>(null)

export const useEmployeeContext = (): EmployeeContextProps => {
  const context = React.useContext(EmployeeContext)

  if (context === null) {
    throw new Error('useEmployeeContext must be used within an EmployeeContext.Provider')
  }

  return context
}
